export let SendStatus;
(function (SendStatus) {
  SendStatus["Sending"] = "sending";
  SendStatus["SendFailed"] = "send failed";
  SendStatus["Sent"] = "sent";
})(SendStatus || (SendStatus = {}));